import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSButtonBlue, NSButtonRed, NSSection, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { AccountLayout } from "../AccountLayout";
import { AccountRouterProps } from "../AccountRouterProps";

interface UserDeletePageProps extends NSARouterMakerResult, AccountRouterProps
{ }

function UserDeletePage(props: UserDeletePageProps) 
{
    function onDelete(onFinished: () => void)
    {
        try
        {
            props.account.server.user.Delete().then(() =>
            {
                props.notifier.onSuccess("Account was scheduled for deletion successfully.");
                onFinished();
            }).catch(onFinished);
        } catch (error)
        {
            props.notifier.onError(error as Error);
            onFinished();
        }
    }

    function onCancel(onFinished: () => void)
    {
        try
        {
            props.account.server.user.Cancel().then(() =>
            {
                props.notifier.onSuccess("The user account deletion cancellation operation was successful.");
                onFinished();
            }).catch(onFinished);
        } catch (error)
        {
            props.notifier.onError(error as Error);
            onFinished();
        }
    }

    let deleted = props.account.token_manager.getUserData(u => u.will_be_deleted_at !== null, true);

    return (
        <AccountLayout {...props}
            title={{
                title: 'Delete Account',
                description: `If you request to delete your account, your account will be deemed inactive unless you cancel your request. If your account remains inactive for 90 days, we will delete your account.`,
            }}
        >
            <NSSection>
                <NSSpace size={NSSpaceSizeType.MICRO}></NSSpace>
                {
                    !deleted ? (
                        <NSButtonRed
                            title="Delete"
                            onClick={{
                                showLoading: true,
                                action: (onFinished) =>
                                {
                                    onDelete(onFinished);
                                }
                            }}
                        />
                    ) : (
                        <NSButtonBlue
                            title="Cancel"
                            onClick={{
                                showLoading: true,
                                action: (onFinished) =>
                                {
                                    onCancel(onFinished);
                                }
                            }}
                        />
                    )}
            </NSSection>
        </AccountLayout>
    );
};
export default UserDeletePage;